/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { DownloadStepFragment } from "@cosmos/hygraph-schema";
import { Fragment } from "react";
import { CosmosTag } from "@components/elements";
import { css, cx } from "@panda/css";
import { flex, vstack } from "@panda/patterns";
import { Divider } from "./Divider.atom";
import { DownloadCard, DownloadCardProps } from "./DownloadCard.molecule";

const renderCards = (content: DownloadCardProps[]): React.JSX.Element => {
	return (
		<div
			className={cx(
				flex({}),
				css({
					flexDirection: "row",
					gap: "eds.dimension.32",
					"& .download-card": {
						flex: "50%",
					},
					smDown: {
						flexDirection: "column",
						gap: "eds.dimension.24",
					},
				}),
			)}
			style={{ flexGrow: 1 }}
		>
			{content.slice(0, 2).map((card, i) => (
				<Fragment key={`card-${i}`}>
					{i == 0 ? null : <Divider />}
					<DownloadCard {...card}></DownloadCard>
				</Fragment>
			))}
		</div>
	);
};

export interface DownloadStepProps extends DownloadStepFragment {
	className?: string;
	content: DownloadCardProps[];
}

export function DownloadStep({ gradient, label, content, className }: DownloadStepProps): React.JSX.Element {
	return (
		<div
			className={cx(
				"download-step",
				className,
				vstack({
					gap: "eds.dimension.24",
					alignItems: "flex-start",
				}),
				css({
					border: "token(spacing.eds.dimension.1) solid token(colors.eds.palette.transparent.light.005)",
					backgroundColor: "eds.palette.transparent.light.005",
					backdropFilter: "var(--effect-material-blur, blur(50px))",
					borderRadius: "eds.dimension.24",
					paddingBlock: "eds.dimension.32",
					paddingInline: "eds.dimension.32",
				}),
			)}
		>
			<CosmosTag gradient={gradient} label={label} size="uiSM" />
			{content ? content.length > 1 ? renderCards(content) : <DownloadCard {...content[0]}></DownloadCard> : undefined}
		</div>
	);
}
